var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaiffaizenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H19V19H1V1Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52063 1.52026H18.4794V18.4794H1.52063V1.52026Z",
    fill: "#FFF200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42043 15.0529L4.63268 17.308L9.8159 12.0492L15.1725 17.4164L17.4171 15.1936L12.1143 9.89153L13.1337 8.90484V6.80132L13.7736 6.25926V7.90725L14.5977 8.57946L17.059 6.1182L17.8505 6.72533C18.3169 5.00136 15.6168 1.08696 13.3831 3.25556L10.7804 5.83607L11.3119 6.47593L9.98892 7.76618L8.70958 6.50827L9.38179 5.90075L6.53007 3.14684C4.38328 1.37922 2.18195 4.06884 2.10596 6.6926L2.8865 6.04221L5.28268 8.6231L6.13921 7.90764V6.32434L6.67035 6.72533V8.79651L7.7112 9.83736L2.42043 15.0529Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiffaizenIcon);
export default __webpack_public_path__ + "static/media/raiffaizen-icon.90072a41c5e50c295ed68ac656b5c4f2.svg";
export { ForwardRef as ReactComponent };